import { IconStorage } from "@app/shared/icons/interfaces";

export const expandV1: IconStorage = {
  svgCode: () => ([
    "M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15",
  ]),
};
